import { IFootballConfig, ITeamSquadItem } from '../../../../packages/types';
import { LinkCreationService, removeUndefinedPropertiesFromObject } from '../../../../packages/utils';
import { INormalizedTeamSquadItem, TeamPlayerStat } from '../types';
import { assetsPlaceholder } from '../../../../packages/constants/assetsPlaceholder';
import { NOT_AVAILABLE } from '../../../../packages/constants/notAvailable';
import { TARGET_BLANK, TARGET_SELF } from '../../../../packages/constants/windowTarget';
import { PLAYER_ENTITY } from '../../../../packages/constants/entityTypes';
import { getTeamPlayerStatValue } from '../utils/getTeamPlayerStatValue';

interface INormalizeTeamSquadItemDataArgs {
  item: ITeamSquadItem;
  dataEntityLinks?: IFootballConfig['dataEntityLinks'];
  dataTeamNameType?: IFootballConfig['dataTeamNameType'];
  playerStats?: TeamPlayerStat[];
  goalkeeperStats?: TeamPlayerStat[];
  displayImage?: IFootballConfig['dataImageDisplay'];
}

export const normalizeTeamSquadItem = ({
  item,
  dataEntityLinks,
  playerStats,
  goalkeeperStats,
  displayImage,
}: INormalizeTeamSquadItemDataArgs): INormalizedTeamSquadItem | undefined => {
  if (!item) return;

  const linkService = dataEntityLinks && new LinkCreationService(dataEntityLinks);

  const playerAge = Math.floor((new Date().valueOf() - new Date(item.player.birthdate).getTime()) / 3.15576e10);

  // Use goalkeeperStats if the player's position is 'keeper', otherwise use playerStats
  const stats = item.position === 'keeper' ? goalkeeperStats : playerStats?.filter((stat) => !['conceded'].includes(stat));

  const statsColumns =
    stats?.map((stat) => ({
      value: getTeamPlayerStatValue(stat, item, playerAge),
      type: 'text',
      position: item.position,
      css: { width: '$6', textAlign: 'center' },
    })) ?? [];

  const columns = [
    {
      value: item?.shirtNumber,
      type: 'text',
      css: { mr: '$3', mx: '12px', width: '$3', textAlign: 'center' },
    },
    {
      value: item?.player.thumb || assetsPlaceholder.participantPlayer,
      type: 'image',
      alt: item?.player?.name,
      css: { display: displayImage ? 'block' : 'none' },
    },
    {
      value: item.player.name ? item.player.name : NOT_AVAILABLE,
      eventValues: { id: item?.player?.id, name: item?.player?.name },
      link: linkService?.createEntityUrl(String(item?.player?.id), PLAYER_ENTITY, '', item?.player?.slug) ?? '#',
      urlTarget: dataEntityLinks?.configuration?.newWindow ? TARGET_BLANK : TARGET_SELF,
      type: 'link',
      css: { flexGrow: '1' },
      countryName: item?.player?.country?.name,
      countryFlag: item?.player?.country?.url_flag,
    },
    ...statsColumns,
  ];

  return removeUndefinedPropertiesFromObject({
    desktopColumns: columns,
    mobileColumns: columns,
  });
};
